<template>
  <div v-html="formattedHtml" class="formatted-html-content"></div>
</template>

<style lang="scss" scoped>
.formatted-html-content {
  // Simple link styling with underline
  ::v-deep a {
    text-decoration: underline;
    text-underline-offset: 2px;
    transition: text-decoration-thickness 0.2s ease;

    &:hover {
      text-decoration-thickness: 2px;
      cursor: pointer;
    }

    &:focus {
      outline: 2px solid currentColor;
      outline-offset: 2px;
      border-radius: 2px;
    }
  }
}
</style>

<script>
import router from "@/router";

export default {
  name: "FormattedHtml",
  props: {
    html: {
      type: String,
      required: true
    }
  },
  computed: {
    formattedHtml() {
      // Nimm den HTML-Inhalt entgegen und wende die Transformation an
      let source = this.html;
      router.getRoutes().forEach((route) => {
        source = source.replaceAll(`href="${route.name}"`, `href="${route.path}"`);
        source = source.replaceAll(`(${route.name})`, `(${route.path})`);
      });
      return source;
    }
  }
};
</script>
